/**
 * `sold_out` is written by the API's scheduled job and is `null` until the job has run for the flow.
 * The job skips flows with `sold_out_override` set, so the override must take precedence.
 */
type FlowSoldOutMeta = {
  sold_out?: boolean | null
  sold_out_override?: boolean
}

export function isFlowSoldOut(meta: FlowSoldOutMeta): boolean {
  return meta.sold_out_override ?? meta.sold_out ?? false
}

/**
 * TODO Remove this once we are confident that bundles with `sold_out_override: false` have been updated.
 *
 * Removes a stored `sold_out_override: false` so the next save clears it and the sold-out job
 * recalculates the flow again. The CMS only exposes "sold out" or "automatic", never "force available".
 */
export function dropFalseSoldOutOverride(meta: FlowSoldOutMeta): void {
  if (meta.sold_out_override === false) {
    delete meta.sold_out_override
  }
}
